<template>
    <CommonBox :title="titles[updateType]" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-width="150px" :model="initForm" :rules="rules">
            <el-form-item label="Product Category" prop="ProductCategory">
                <el-input v-model="initForm.ProductCategory"></el-input>
            </el-form-item>

        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    props:{
        updateType:{},
        initForm:{}
    },
    data () {
        return {
            titles:{
                add:"Add Category",
                edit:"Edit Category"
            },
            rules:{
                ProductCategory:[{required: true, message: 'Please enter a category name', trigger: 'blur'}]
            }};
    },
    created () {},
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let methods = this.updateType === 'add' ? 'post' : 'put';
                let url = this.updateType === 'add' ? 'addDocumentsProductCategory' : 'editDocumentsProductCategory';
                this.$http[methods](url,this.initForm,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>
